<template>
  <div class="container-fluid py-4">

    <div class="card card-q">
      <div class="card-body">

        <!-- header: título izquierda / buscador derecha -->
        <div class="header-descuentos mb-3">
          <div>
            <h5 class="mb-0 titulo-listado">Listado de Descuentos</h5>
            <p class="text-sm mb-0 opacity-7">Descuentos por producto (activar / desactivar).</p>
          </div>

          <div class="header-actions">
            <select
              v-if="miRol == 1"
              v-model="filtroTipsterId"
              class="form-control form-control-sm filtro-tipster-select"
              @change="cargar"
            >
              <option value="">Todos los tipsters</option>
              <option v-for="t in listaTipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
            </select>

            <div class="buscador-wrap">
              <i class="fa fa-search buscador-icon"></i>
              <input
                v-model.trim="q"
                class="form-control form-control-sm buscador-input"
                placeholder="Búsqueda rápida…"
                @keyup.enter="cargar"
              />
            </div>

            <button class="btn btn-sm btn-outline-primary" @click="cargar" :disabled="loading">
              <i class="fa fa-refresh me-1"></i> Refrescar
            </button>
          </div>
        </div>

        <div v-if="loading" class="text-sm opacity-7">Cargando descuentos…</div>

        <div v-else>
          <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>

          <div v-if="!rows.length" class="text-sm opacity-7">No hay descuentos para mostrar.</div>

          <div v-else class="table-responsive">
            <table class="table table-q align-items-center mb-0">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Tipster</th>
                  <th>Código</th>
                  <th>%</th>
                  <th>Usos</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="d in rows" :key="d.id">
                  <td>
                    <div class="d-flex flex-column">
                      <span class="text-sm font-weight-bold">{{ d.producto_nombre || "—" }}</span>
                      <small class="opacity-7">#{{ d.producto_id }} · {{ money(d.producto_precio) }}</small>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex flex-column">
                      <span class="text-sm font-weight-bold">{{ d.tipster_nombre || "—" }}</span>
                      <small class="opacity-7">#{{ d.producto_tipsterid ?? "—" }}</small>
                    </div>
                  </td>

                  <td>
                    <QBadge :label="d.codigo" status="info" />
                  </td>

                  <td class="text-center text-sm">
                    {{ Number(d.porcentaje ?? 0).toFixed(2) }}%
                  </td>

                  <td class="text-center text-sm">
                    <span class="font-weight-bold">{{ Number(d.usados ?? 0) }}</span>
                    <span class="opacity-7">/ {{ d.usos_maximos ?? "∞" }}</span>
                  </td>

                  <td class="text-center">
                    <QBadge :status="Number(d.activo) === 1 ? 'activo' : 'inactivo'" />
                  </td>

                  <td class="text-end">
                    <button
                      class="btn btn-sm"
                      :class="Number(d.activo) === 1 ? 'btn-outline-danger' : 'btn-outline-success'"
                      :disabled="togglingId === d.id"
                      @click="toggle(d)"
                    >
                      {{ Number(d.activo) === 1 ? "Desactivar" : "Activar" }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="text-sm opacity-7 mt-3">
              Mostrando 1 a {{ rows.length }} de {{ rows.length }} registros
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>


<script>
import api from "@/services/apiClient";

export default {
  name: "Descuentos",
  data() {
    return {
      loading: false,
      error: "",
      q: "",
      rows: [],
      togglingId: null,
      listaTipsters: [],
      filtroTipsterId: '',
    };
  },
  computed: {
    miRol() { return this.$store.getters["auth/rolEfectivo"]; },
  },
  methods: {
    apiBase() {
      return process.env.VUE_APP_API_BASE_URL + "/api/v2";
    },
    money(v) {
      const n = Number(v ?? 0);
      return n.toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
    async cargar() {
      this.loading = true;
      this.error = "";
      try {
        const url = `${this.apiBase()}/descuentos`;
        const resp = await api.post(url, { q: this.q || "", tipster_id: this.filtroTipsterId || null });

        if (resp?.data?.res !== "OK") {
          throw new Error(resp?.data?.mensaje || "Respuesta inválida");
        }
        this.rows = Array.isArray(resp.data.data) ? resp.data.data : [];
      } catch (e) {
        this.error =
          e?.response?.data?.mensaje ||
          e?.response?.data?.message ||
          e?.message ||
          "Error cargando descuentos";
      } finally {
        this.loading = false;
      }
    },
    async toggle(d) {
      if (!d?.id) return;
      this.togglingId = d.id;
      this.error = "";

      try {
        const url = `${this.apiBase()}/descuentosToggle`;
        const resp = await api.post(url, { id: d.id });

        if (resp?.data?.res !== "OK") {
          throw new Error(resp?.data?.mensaje || "No se pudo cambiar el estado");
        }

        const idx = this.rows.findIndex((x) => x.id === d.id);
        if (idx !== -1) {
          this.rows[idx].activo = Number(resp.data.activo);
        }
      } catch (e) {
        this.error =
          e?.response?.data?.mensaje ||
          e?.response?.data?.message ||
          e?.message ||
          "Error cambiando estado";
      } finally {
        this.togglingId = null;
      }
    },
  },
  async mounted() {
    this.cargar();
    if (Number(this.miRol) === 1) {
      const tipsters = await this.$store.dispatch("auth/listaTipsters");
      this.listaTipsters = Array.isArray(tipsters) ? tipsters : [];
    }
  },
};
</script>
<style scoped>
.card-q{
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0,0,0,.05);
}

.titulo-listado{
  font-weight: 700;
}

.buscador-wrap{
  position: relative;
  width: 320px;
  max-width: 75vw;
}

.buscador-icon{
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  opacity: .55;
  font-size: 0.8125rem;
}

.buscador-input{
  padding-left: 30px;
  border-radius: 999px;
}

/* tabla similar a la de productos */
.table-q thead th{
  background: var(--q-hover);
  color: var(--q-text);
  font-weight: 700;
  font-size: 0.75rem;
  text-transform: none;
  border-bottom: 0;
  white-space: nowrap;
}

.table-q tbody tr:nth-child(even){
  background: var(--q-hover);
}

.table-q td, .table-q th{
  vertical-align: middle;
}
/* Mata bordes por si algún CSS global se puso creativo */
.table-q,
.table-q th,
.table-q td {
  border: 0 !important;
}

/* Bootstrap a veces mete border-bottom en celdas */
.table-q > :not(caption) > * > * {
  border-bottom-width: 0 !important;
}

/* Por si alguna regla mete bordes verticales */
.table-q th,
.table-q td {
  border-left: 0 !important;
  border-right: 0 !important;
}
.header-descuentos{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.header-actions{
  display: flex;
  align-items: center;
  gap: 12px;
}

.filtro-tipster-select{
  min-width: 180px;
  font-size: 0.82rem;
  border-radius: 999px;
}

/* 🔥 RESPONSIVE REAL */
@media (max-width: 768px){

  .header-descuentos{
    flex-direction: column;
    align-items: stretch;
  }

  .header-actions{
    flex-direction: column;
    width: 100%;
  }

  .header-actions button{
    width: 100%;
  }

  .buscador-wrap{
    width: 100%;
    max-width: 100%;
  }

}
</style>
